(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-search-area.js') >= 0) return;  svs.modules.push('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-search-area.js');

'use strict';

const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  ReactButton: Button,
  ReactIcon: Icon,
  ReactPaper: Paper
} = svs.ui;
const {
  login
} = svs.components.customer_login;
const {
  selectSearchFilters
} = svs.components.marketplaceShared.coOpPlay.selectors;
const {
  updateFilterAction
} = svs.components.marketplaceShared.coOpPlay.actions;
const {
  FILTER_QUERY_NAME,
  FILTER_FRACTION_PRICE
} = svs.components.marketplaceShared.sharedConstants.constants;
const {
  SearchFilterName,
  SearchFilterPrice
} = svs.components.marketplaceShared.searchFilters;
const RetailerSearchArea = _ref => {
  let {
    branding,
    onChange
  } = _ref;
  const dispatch = useDispatch();
  const isUserLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const updateFilter = filter => dispatch(updateFilterAction(filter));
  const {
    fractionPriceMax,
    fractionPriceMin
  } = useSelector(selectSearchFilters);
  const searchQuery = useSelector(state => {
    var _state$CoOpPlayFilter;
    return (state === null || state === void 0 || (_state$CoOpPlayFilter = state.CoOpPlayFilter) === null || _state$CoOpPlayFilter === void 0 ? void 0 : _state$CoOpPlayFilter.searchName) || '';
  });
  const renderSearchFilterName = () => React.createElement(SearchFilterName, {
    filterNameKey: FILTER_QUERY_NAME,
    nameSearchQuery: searchQuery,
    placeHolder: "Ombud, spelnamn, spell\xE4ggare, ort",
    updateFilter: onChange
  });
  const renderSearchFilterFractions = () => React.createElement(SearchFilterPrice, {
    branding: branding,
    filterPriceKey: FILTER_FRACTION_PRICE,
    fractionPriceMax: fractionPriceMax,
    fractionPriceMin: fractionPriceMin,
    updateFilter: updateFilter
  });
  return React.createElement(React.Fragment, null, React.createElement(Paper, {
    branding: "sport",
    className: "co-op-play-container co-op-play-filters"
  }, React.createElement("div", {
    className: "co-op-play-filters-inner"
  }, React.createElement("div", {
    className: "search-input search-input-".concat(branding)
  }, renderSearchFilterName()), React.createElement("div", null, React.createElement("div", {
    className: "co-op-play-filters-fractions align-center f-550"
  }, renderSearchFilterFractions())))), !isUserLoggedIn && React.createElement(Paper, {
    branding: "sport",
    className: "co-op-play-container co-op-play-login"
  }, React.createElement("div", {
    className: "co-op-play-login-inner"
  }, React.createElement("div", {
    className: "co-op-play-login-content"
  }, React.createElement(Icon, {
    color: "fc-white",
    icon: "login",
    size: "600"
  }), React.createElement("span", {
    className: "h4"
  }, "Logga in f\xF6r att visa spel fr\xE5n dina ombud!")), React.createElement(Button, {
    block: true,
    className: "btn-".concat(branding),
    inverted: true,
    onClick: login
  }, "Logga in"))));
};
RetailerSearchArea.defaultProps = {
  branding: 'sport'
};
setGlobal('svs.components.tipsen.RetailerSearchArea', RetailerSearchArea);

 })(window);